import { IcoDocument, IcoMusic, IcoVideoCamera } from '@components/icons';
import { IcoPlay } from '@components/icons/video-player';
import { isAudio, isImage, isVideo } from 'shared/media';
import { useState } from 'preact/hooks';

type Props = {
  type: string;
  name: string;
  publicUrl: string;
  posterUrl: string | undefined;
  class?: string;
  iconClass?: string;
  showPlayOverlay?: boolean;
};

export function FileThumbnail({
  type,
  name,
  publicUrl,
  posterUrl,
  class: className = 'size-12',
  iconClass = 'size-5',
  showPlayOverlay,
}: Props) {
  const [failed, setFailed] = useState(false);
  const wantsPlay = showPlayOverlay && (isVideo(type) || isAudio(type));

  const src = isImage(type) ? publicUrl : isVideo(type) ? posterUrl : undefined;

  if (src && !failed) {
    return (
      <div
        class={`${className} relative shrink-0 overflow-hidden bg-gray-100 flex items-center justify-center`}
      >
        <img
          src={src}
          alt={name}
          loading="lazy"
          class="w-full h-full object-cover"
          onError={() => setFailed(true)}
        />
        {wantsPlay && <PlayOverlay />}
      </div>
    );
  }

  const Icon = isVideo(type) ? IcoVideoCamera : isAudio(type) ? IcoMusic : IcoDocument;
  return (
    <div
      class={`${className} relative shrink-0 bg-gray-100 text-gray-500 flex items-center justify-center`}
    >
      <Icon class={iconClass} />
      {wantsPlay && <PlayOverlay />}
    </div>
  );
}

function PlayOverlay() {
  return (
    <span class="absolute inset-0 flex items-center justify-center pointer-events-none">
      <span class="flex items-center justify-center size-10 rounded-full bg-black/55 text-white">
        <IcoPlay class="size-5 translate-x-px" />
      </span>
    </span>
  );
}

export function categoryLabel(type: string): string {
  if (isImage(type)) {
    return 'Image';
  }
  if (isVideo(type)) {
    return 'Video';
  }
  if (isAudio(type)) {
    return 'Audio';
  }
  return 'Document';
}
